var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1984.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Login",
    transform: "translate(445.000000, 1984.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0000187,2 C30.6570084,2 32,3.343 32,5 L32,5 L32,31 L19.0000812,31 C17.3430916,31 16.0001,29.657 16.0001,28 L16.0001,28 L16.0001,2 Z M7.30195436,8.8019 L14.9999063,16.4999 L7.30195436,24.1979 C6.23896101,23.1359 6.23896101,21.4119 7.30195436,20.3499 L7.30195436,20.3499 L9.78993881,17.8609 L0.00099999375,17.8609 L0,15.1389 L9.78993881,15.1389 L7.30195436,12.6509 C6.23896101,11.5879 6.23896101,9.8639 7.30195436,8.8019 L7.30195436,8.8019 Z M20.5000719,14 C19.1190805,14 18.0000875,15.119 18.0000875,16.5 C18.0000875,17.881 19.1190805,19 20.5000719,19 C21.8810632,19 23.0000562,17.881 23.0000562,16.5 C23.0000562,15.119 21.8810632,14 20.5000719,14 Z",
    id: 182
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionLogin);
export default __webpack_public_path__ + "static/media/navigation-and-action-login.a3dc7ae0.svg";
export { ForwardRef as ReactComponent };